import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=3cd0a922&"
import script from "./FormRegister.vue?vue&type=script&lang=ts&"
export * from "./FormRegister.vue?vue&type=script&lang=ts&"
import style0 from "./FormRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports